import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-167cb996")

_pushScopeId("data-v-167cb996")
const _hoisted_1 = {
  key: 0,
  style: {"width":"700px"},
  class: "relative pt-6 edit-body overflow-y-auto"
}
const _hoisted_2 = {
  key: 1,
  style: {"width":"700px"},
  class: "relative pt-6 edit-body overflow-y-auto"
}
const _hoisted_3 = { class: "grid grid-cols-2 gap-x-24 gap-y-8 text-black-lp-300" }
const _hoisted_4 = { class: "flex flex-col gap-y-2" }
const _hoisted_5 = { class: "flex flex-col gap-y-2" }
const _hoisted_6 = { class: "flex flex-col gap-y-2" }
const _hoisted_7 = { class: "flex flex-col gap-y-2" }
const _hoisted_8 = { class: "flex flex-col gap-y-2 col-span-2" }
const _hoisted_9 = /*#__PURE__*/_createVNode("hr", { class: "col-span-2" }, null, -1)
const _hoisted_10 = { class: "flex flex-col gap-y-2" }
const _hoisted_11 = { class: "flex flex-col gap-y-2" }
const _hoisted_12 = { class: "flex flex-col gap-y-2" }
const _hoisted_13 = { class: "flex flex-col gap-y-2" }
const _hoisted_14 = { class: "flex flex-col gap-y-2" }
const _hoisted_15 = { class: "flex flex-col gap-y-2" }
const _hoisted_16 = {
  key: 2,
  style: {"width":"700px"},
  class: "relative pt-6 edit-body overflow-y-auto"
}
const _hoisted_17 = { class: "grid grid-cols-2 gap-x-24 gap-y-8 text-black-lp-300" }
const _hoisted_18 = { class: "mt-2" }
const _hoisted_19 = { class: "mt-2 w-full break-all" }
const _hoisted_20 = { class: "mt-2" }
const _hoisted_21 = { class: "mt-2" }
const _hoisted_22 = { class: "mt-2" }
const _hoisted_23 = /*#__PURE__*/_createVNode("hr", { class: "col-span-2" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("p", { class: "text-16px font-semibold" }, "Detail Rekening Pengirim", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("p", { class: "text-16px font-semibold" }, "Detail Rekening Penerima", -1)
const _hoisted_26 = { class: "mt-2" }
const _hoisted_27 = { class: "mt-2" }
const _hoisted_28 = { class: "mt-2" }
const _hoisted_29 = { class: "mt-2" }
const _hoisted_30 = { class: "mt-2" }
const _hoisted_31 = { class: "mt-2" }
const _hoisted_32 = /*#__PURE__*/_createVNode("hr", { class: "col-span-2" }, null, -1)
const _hoisted_33 = { class: "mt-2 flex flex-col" }
const _hoisted_34 = { class: "text-gray-lp-500" }
const _hoisted_35 = { class: "mt-2 flex flex-col" }
const _hoisted_36 = { class: "text-gray-lp-500" }
const _hoisted_37 = { class: "grid grid-cols-2 gap-x-24 gap-y-8 my-8 text-black-lp-300" }
const _hoisted_38 = { class: "mt-2 flex flex-col" }
const _hoisted_39 = { class: "text-gray-lp-500" }
const _hoisted_40 = { class: "flex flex-col" }
const _hoisted_41 = { class: "flex flex-row justify-between text-black-lp-300 text-12px xxl:text-14px" }
const _hoisted_42 = /*#__PURE__*/_createVNode("p", { class: "font-semibold" }, "Bukti transfer", -1)
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Download ")
const _hoisted_44 = {
  key: 0,
  class: "mt-2 flex flex-row justify-center border border-gray-lp-400 border-dashed rounded-md"
}
const _hoisted_45 = {
  key: 1,
  class: "mt-2"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_error_message = _resolveComponent("error-message")!
  const _component_skeleton = _resolveComponent("skeleton")!
  const _component_data_wrapper = _resolveComponent("data-wrapper")!
  const _component_DownloadAttachment = _resolveComponent("DownloadAttachment")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    modelValue: _ctx.isShowRequestTopupManualDetail,
    persistent: true,
    title: `ID: ${_ctx.detailData?.tumId}`,
    class: "topup-manual-detail",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = 
      () => {
        _ctx.showModalRequestTopupManualDetail(false);
      }
    )
  }, {
    default: _withId(() => [
      (_ctx.isError && !_ctx.isLoading)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode(_component_error_message, {
              errorType: _ctx.errorCause,
              onTryAgain: _ctx.getDetail
            }, null, 8, ["errorType", "onTryAgain"])
          ]))
        : (_ctx.isLoading)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode(_component_skeleton, { width: "50%" }),
                  _createVNode(_component_skeleton)
                ]),
                _createVNode("div", _hoisted_5, [
                  _createVNode(_component_skeleton, { width: "50%" }),
                  _createVNode(_component_skeleton)
                ]),
                _createVNode("div", _hoisted_6, [
                  _createVNode(_component_skeleton, { width: "50%" }),
                  _createVNode(_component_skeleton)
                ]),
                _createVNode("div", _hoisted_7, [
                  _createVNode(_component_skeleton, { width: "50%" }),
                  _createVNode(_component_skeleton)
                ]),
                _createVNode("div", _hoisted_8, [
                  _createVNode(_component_skeleton, { width: "20%" }),
                  _createVNode(_component_skeleton),
                  _createVNode(_component_skeleton, { width: "50%" })
                ]),
                _hoisted_9,
                _createVNode("div", _hoisted_10, [
                  _createVNode(_component_skeleton, { width: "50%" }),
                  _createVNode(_component_skeleton)
                ]),
                _createVNode("div", _hoisted_11, [
                  _createVNode(_component_skeleton, { width: "50%" }),
                  _createVNode(_component_skeleton)
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode(_component_skeleton, { width: "50%" }),
                  _createVNode(_component_skeleton)
                ]),
                _createVNode("div", _hoisted_13, [
                  _createVNode(_component_skeleton, { width: "50%" }),
                  _createVNode(_component_skeleton)
                ]),
                _createVNode("div", _hoisted_14, [
                  _createVNode(_component_skeleton, { width: "50%" }),
                  _createVNode(_component_skeleton)
                ]),
                _createVNode("div", _hoisted_15, [
                  _createVNode(_component_skeleton, { width: "50%" }),
                  _createVNode(_component_skeleton)
                ])
              ])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_16, [
              _createVNode("div", _hoisted_17, [
                _createVNode(_component_data_wrapper, { label: "ID" }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_18, _toDisplayString(_ctx.detailData?.tumId), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_data_wrapper, { label: "Genesis Transaksi ID" }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_19, _toDisplayString(_ctx.detailData.tumlGenesisTransactionId), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_data_wrapper, { label: "Jumlah Permintaan" }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_20, _toDisplayString(_ctx.formatPrice(_ctx.detailData.tumAmount)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_data_wrapper, { label: "Status" }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_21, [
                      _createVNode("span", {
                        class: ["px-2 rounded-full font-medium capitalize", 
                `${
                  _ctx.detailData.tumStatus.toLowerCase() === 'pending'
                    ? 'bg-gray-lp-200 text-black-lp-300'
                    : _ctx.detailData.tumStatus.toLowerCase() === 'verified'
                    ? 'bg-yellow-lp-200 text-yellow-lp-100'
                    : _ctx.detailData.tumStatus.toLowerCase() === 'approved'
                    ? 'bg-green-lp-300 text-green-lp-200'
                    : 'bg-red-lp-600 text-red-lp-500'
                }`
              ]
                      }, _toDisplayString(_ctx.detailData.tumStatus.replace("_", " ")), 3)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_data_wrapper, {
                  label: "Alasan Penolakan",
                  class: "col-span-2"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_22, _toDisplayString(_ctx.detailData.tumRejectReason || "-"), 1)
                  ]),
                  _: 1
                }),
                _hoisted_23,
                _hoisted_24,
                _hoisted_25,
                _createVNode(_component_data_wrapper, { label: "Nama Bank" }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_26, _toDisplayString(_ctx.detailData.tumSenderBankName), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_data_wrapper, { label: "Nama Bank" }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_27, _toDisplayString(_ctx.detailData.tumRecepientBankName), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_data_wrapper, { label: "Nama Rekening" }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_28, _toDisplayString(_ctx.detailData.tumSenderBankAccountName), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_data_wrapper, { label: "Nama Rekening" }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_29, _toDisplayString(_ctx.detailData.tumRecepientBankAccountName), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_data_wrapper, { label: "No. Rekening" }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_30, _toDisplayString(_ctx.detailData.tumSenderBankAccountNumber), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_data_wrapper, { label: "No. Rekening" }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_31, _toDisplayString(_ctx.detailData.tumRecepientBankAccountNumber), 1)
                  ]),
                  _: 1
                }),
                _hoisted_32,
                _createVNode(_component_data_wrapper, { label: "Tanggal Transaksi" }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_33, [
                      _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.detailData.tumCreatedAt)), 1),
                      _createVNode("span", _hoisted_34, _toDisplayString(_ctx.detailData.tumCreatedName), 1)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_data_wrapper, { label: "Tanggal Diverifikasi" }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_35, [
                      _createTextVNode(_toDisplayString(_ctx.detailData.tumVerificationAt
                ? _ctx.formatDate(_ctx.detailData.tumVerificationAt)
                : "-"), 1),
                      _createVNode("span", _hoisted_36, _toDisplayString(_ctx.detailData.tumVerificationAt ? _ctx.detailData.tumVerificationName : ""), 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createVNode("div", _hoisted_37, [
                _createVNode(_component_data_wrapper, { label: "Tanggal Disetujui" }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_38, [
                      _createTextVNode(_toDisplayString(_ctx.detailData.tumApprovalAt
                ? _ctx.formatDate(_ctx.detailData.tumApprovalAt)
                : "-"), 1),
                      _createVNode("span", _hoisted_39, _toDisplayString(_ctx.detailData.tumApprovalAt ? _ctx.detailData.tumApprovalName : ""), 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createVNode("div", _hoisted_40, [
                _createVNode("div", _hoisted_41, [
                  _hoisted_42,
                  (!_ctx.isFilePdf)
                    ? (_openBlock(), _createBlock("div", {
                        key: 0,
                        class: "flex flex-row gap-2 items-center cursor-pointer",
                        onClick: _cache[1] || (_cache[1] = () => _ctx.downloadFile(_ctx.detailData.tumFileOfProof))
                      }, [
                        _hoisted_43,
                        _createVNode("img", {
                          src: require('@/app/ui/assets/svg/download.svg'),
                          alt: "download",
                          class: "w-6 max-w-none"
                        }, null, 8, ["src"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (!_ctx.isFilePdf)
                  ? (_openBlock(), _createBlock("div", _hoisted_44, [
                      _createVNode("img", {
                        src: _ctx.detailData.tumFileOfProof,
                        class: "w-377px max-w-none",
                        alt: "attachment"
                      }, null, 8, ["src"])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_45, [
                      _createVNode(_component_DownloadAttachment, {
                        name: _ctx.fileName,
                        url: _ctx.detailData.tumFileOfProof,
                        maxLength: 45
                      }, null, 8, ["name", "url"])
                    ]))
              ])
            ]))
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
})